(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  // <rotated-marquee> custom HTML Element
  class RotatedMarquee extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  }
  customElements.define('rotated-marquee', RotatedMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-header"] && !Shopify.designMode) return;
  try {
    
  // <content-marquee> custom HTML Element
  class ContentMarquee extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  }
  customElements.define('content-marquee', ContentMarquee);

  } catch(e) { console.error(e); }
})();
})();
